import React from 'react';
import propTypes from 'prop-types';
import styled from '@emotion/styled';
import { theme } from '../../../themes/default-theme';
import RespImg from '../../ui/RespImg';
import Text from '../../typography';
import Link from 'next/link';
import { useMediaQuery } from '@mui/material';
import { setSavedData, getSavedData } from '../../../components/methods/setLocalStorage';


const SeriesCardInnerContainer = styled.div`
    text-align: center;
    // margin:auto;
    a {
        text-decoration: none;
    }
    ${theme.breakpoints.up('md')} {
        padding: 9px 24px 9px 23px;
        margin-bottom: 10px;
        margin-top: 0;
        &, picture, img {
            max-width: 275px;
        }
    }
    ${props => props.mobileStyles && `
        ${theme.breakpoints.down('sm')} {
            ${props => props.hasborder && `
                // padding: 30px 0;
                border-bottom: 1px solid #D6D6D6;
            `}
            a {
                display: flex;
                flex-direction: row-reverse;
                width: 100%;
                align-items: center;
                gap: 10px;
            }
        }
    `}
`
const SeriesCardImage = styled.div`
    ${theme.breakpoints.up('md')} {
        margin-bottom: 5px;
    }
    ${theme.breakpoints.down('sm')} {
        width: 100%;
   }
`
const SeriesCardContent = styled.div`
    h4 {
        color: #0170D4;
        text-transform: uppercase;
        margin-bottom: 5px;
        margin-top: 5px;
    }
    ${theme.breakpoints.up('md')} {
        > * {
            text-align: center;
        }
        h4 {
            font-weight: 800;
            font-size: 24px;
            line-height: 24px;
            text-align: center;
            letter-spacing: 1px;
        }
    }
    ${theme.breakpoints.down('sm')} {
        width: 100%;
        h4 {
            font-weight: 800;
            font-size: 18px;
            line-height: 24px;
        }
    }
`
const SeriesCardContentBottom = styled.div`
   

    ${props => props.mobileStyles && `
        justify-content: center;
    `}

    ${theme.breakpoints.up('md')} {
        display: flex;
        justify-content: center;
        > * {
            font-weight: 500;
            font-size: 12px;
            line-height: 21px;
            color: #758094;
            &:first-child {
                margin-right: 8px;
                padding-right: 8px;
                position: relative;
                text-transform: capitalize;
                &:after {
                    content: '';
                    position: absolute;
                    width: 1px;
                    height: 12px;
                    background: #758094;
                    right: 0;
                    top: 50%;
                    transform: translateY(-50%);
                }
            }
        }
    }
    ${theme.breakpoints.down('sm')} {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 5px;
        > * {
            font-weight: 500;
            font-size: 12px;
            line-height: 21px;
            color: #758094;
        }
    }

`

const modelSeriesCardDefaultPropImage = {};
const modelSeriesCardDefaultPropRefactorURL = (url) => { return url };
const modelSeriesCardDefaultPropHandleSaveData = () => {};

const ModelSeriesCard = (props) => {
    props = {
        ...props,
        title: typeof props.title === "undefined" ? null : props.title,
        href: typeof props.href === "undefined" ? null : props.href,
        subTitle: typeof props.subTitle === "undefined" ? null : props.subTitle,
        sleeps: typeof props.sleeps === "undefined" ? null : props.sleeps,
        image: typeof props.image === "undefined" ? modelSeriesCardDefaultPropImage : props.image,
        hasBorder: typeof props.hasBorder === "undefined" ? null : props.hasBorder,
        refactorURL: typeof props.refactorURL === "undefined" ? modelSeriesCardDefaultPropRefactorURL : props.refactorURL,
        mobileStyles: typeof props.mobileStyles === "undefined" ? true : props.mobileStyles,
        handleSaveData: typeof props.handleSaveData === "undefined" ? modelSeriesCardDefaultPropHandleSaveData : props.handleSaveData
    };

    const {
        title,
        href,
        subTitle,
        sleeps,
        image,
        hasBorder,
        refactorURL,
        mobileStyles,
        handleSaveData
    } = props;

    // Media Breakpoint Start
    const mediaUp = useMediaQuery(theme.breakpoints.up('md'));
    const mediaDown = useMediaQuery(theme.breakpoints.down('sm'));
    // Media Breakpoint End
    let res = JSON.parse(getSavedData('BuildPriceData')) || {};
    // console.log('res', res)
    return (
        <SeriesCardInnerContainer hasborder={hasBorder} mobileStyles={mobileStyles}>
            <Link href={href} onClick={() => handleSaveData(title)}>

                <SeriesCardImage>
                    {image &&
                        <RespImg
                            {...image}
                            type="png"
                        />
                    }
                </SeriesCardImage>
                <SeriesCardContent>
                    {title &&
                        <Text variant="h4">{title}</Text>
                    }
                    <SeriesCardContentBottom mobileStyles={mobileStyles}>
                        {subTitle &&
                            <Text variant="body2">{subTitle}</Text>
                        }
                        {sleeps &&
                            <Text variant="body2">{`${mediaUp ? 'Sleeps' : 'Sleeps up to'} ${sleeps}`}</Text>
                        }
                    </SeriesCardContentBottom>
                </SeriesCardContent>

            </Link>
        </SeriesCardInnerContainer>
    );
}

ModelSeriesCard.propTypes = {
    title: propTypes.string,
    href: propTypes.string,
    subTitle: propTypes.string,
    sleeps: propTypes.any,
    image: propTypes.object,
    hasBorder: propTypes.bool,
    refactorURL: propTypes.func,
    mobileStyles: propTypes.bool,
    handleSaveData: propTypes.func
}

export default ModelSeriesCard
